module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-14.95d65c72.jpg";